import { render, staticRenderFns } from "./QOptionReadonly.vue?vue&type=template&id=3d65b194&scoped=true&"
import script from "./QOptionReadonly.vue?vue&type=script&lang=js&"
export * from "./QOptionReadonly.vue?vue&type=script&lang=js&"
import style0 from "./QOptionReadonly.vue?vue&type=style&index=0&id=3d65b194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65b194",
  null
  
)

export default component.exports